import React from 'react';
import '../../../assets/scss/toggle-switch.scss';
import '../../../assets/scss/checkbox.scss';

export const ToggleSwitch = ({ title, disabled, onChange, checked, defaultChecked, className }) =>
    <label className={`switch ${className || ""} ${disabled ? "disabled" : ""}`} title={title}>
        <input
            type="checkbox"
            onChange={onChange}
            {...checked !== null ? { checked } : {}}
            defaultChecked={defaultChecked}
            {...disabled ? { disabled } : {}}
        />
        <span className={`slider round`}></span>
    </label>;

export const Checkbox = ({ checked, defaultChecked, onChange, className }) =>
    <div className="checkmark-container">
        <input
            type="checkbox"
            defaultChecked={defaultChecked}
            checked={checked}
            onChange={onChange} />
        <span className={`checkmark ${className ? className : ''}`}></span>
    </div>;